export default "__VITE_ASSET__C8pKL$9O__"